import { createFileRoute, notFound } from "@tanstack/react-router";
import { helpSearch } from "../../src/lib/help-navigation";
import { helpHead } from "../lib/help-route";
import { loadHelpArticle } from "../platform/help";
import { HelpArticle } from "../platform/help/help-pages";

export const Route = createFileRoute("/help/articles/$slug")({
  validateSearch: helpSearch,
  loaderDeps: ({ search }) => ({ audience: search.audience }),
  loader: async ({ params, deps }) => {
    const page = await loadHelpArticle({ data: { ...deps, slug: params.slug } });
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) => helpHead(matches, loaderData),
  component: () => <HelpArticle page={Route.useLoaderData()} />,
});
